var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.572867 4.84765L2.61176 4.84765V1.21191C2.61176 0.54536 3.12432 0 3.7508 0C4.37727 0 4.88984 0.54536 4.88984 1.21191V4.84765H6.92873C7.4413 4.84765 7.69189 5.50208 7.3274 5.87777L4.14946 9.259C3.92166 9.50139 3.56855 9.50139 3.34074 9.259L0.162812 5.87777C0.0841007 5.79234 0.0309191 5.68402 0.00997066 5.56648C-0.0109777 5.44894 0.00124502 5.32743 0.0450964 5.21727C0.0889482 5.10711 0.162467 5.01322 0.256387 4.94745C0.350308 4.88167 0.460427 4.84694 0.572867 4.84765Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallDownArrow);
export default __webpack_public_path__ + "static/media/small-down-arrow.5435765c6e3afe1902664f265e56da39.svg";
export { ForwardRef as ReactComponent };